<div class="id-card-container">
  <div class="id-card">
    
    <div class="card-header">
      <div class="brand">
        <img src="/assets/images/logo_flat.png" alt="Horizinns Logo" class="card-logo">
        <span class="brand-name">HORIZINNS</span>
      </div>
      
      <div class="photo-container">
        <div class="photo-placeholder">
          <i class="fa-solid fa-user-tie"></i>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="agent-details">
        <h3 class="name">{{ agent.firstName }} {{ agent.lastName }}</h3>
        <p class="title">REGISTERED SALES AGENT</p>
        <p class="id-number">ID: {{ agent.agentId }}</p>
      </div>
    </div>

    <div class="card-footer">
      <div class="meta">
        <span class="label">SINCE</span>
        <span class="value">{{ agent.createdAt | date: 'MMMM y' | uppercase }}</span>
      </div>
      <div class="contact">
        <i class="fa-solid fa-envelope"></i> {{ agent.email }}
      </div>
    </div>

    <div class="hologram"></div>
  </div>
</div>
<!-- <div class="id-card-container">
  <div class="id-card">
    
    <div class="card-header">
      <div class="brand">
        <img src="/assets/images/logo_flat.png" alt="Horizinns Logo" class="card-logo">
        <span class="brand-name">HORIZINNS</span>
      </div>
    </div>

    <div class="card-body">
      <div class="photo-container">
        <div class="photo-placeholder">
          <i class="fa-solid fa-user-tie"></i>
        </div>
      </div>
      
      <div class="agent-details">
        <h3 class="name">{{ agent.firstName }} {{ agent.lastName }}</h3>
        <p class="title">OFFICIAL SALES AGENT</p>
        <p class="id-number">ID: {{ agent.agentId }}</p>
      </div>
    </div>

    <div class="card-footer">
      <div class="meta">
        <span class="label">MEMBER SINCE</span>
        <span class="value">2024</span>
      </div>
      <div class="contact">
        <i class="fa-solid fa-envelope"></i> {{ agent.email }}
      </div>
    </div>

    <div class="hologram"></div>
  </div>
</div> -->